// Modal Plugin
(function ( $, window, document, undefined ) {
    var pluginName = 'modal',
        d = document,
        defaults = {
            background          : null
            , bgClose           : true
            , position          : 'modal-centered'
            , dialog            : false
            , width             : null
            , disableTrigger    : false
            , accept            : null
            , decline           : null
            , onInit            : function(){}
            , onShow            : function(){}
            , beforeShowModal   : function(){}
            , onClose           : function(){}
            , afterShowModal    : function(){}
            , afterCloseModal   : function(){}
            , labelledById      : "modal-title"
            , describedById     : "modal-description"
        };



    function Modal( element, options ){
        this.element = element;
        this.$element = $(element);
        // TODO : plugin should be reworked so that the target is the modal itself, not the triggers
        // TODO : triggers should be added as a param
        this.targetElement = this.$element.attr('href') || this.$element.attr('data-modal-id') || this.$element;
        this.$modal = $(this.targetElement);
        this.options = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;

        this.init(this.$modal, this.options);

    }

    Modal.prototype = {
        // cache
        tabindexAdded : [],
        fakeButtonsSelector : null,
        $visibleFocusableElements : null,
        $firstFocusable : null,
        $lastFocusable : null,

        init: function(modal, options){
            // make sure the modal hasn't already been built
            if ( ! modal.parent().hasClass('ui-modal-container') ){
                this.buildModal(modal, options);
            }

            var el = this;

            // classes used to style span elements to look like buttons
            // used to add tabindex to elements to make focusable
            el.fakeButtonsSelector = '.ui-button, .ui-button-medium, .ui-button-small, .ui-confirm-button, .bind-accept, .alt-action, .button-bar-option, .close-modal, .close-modal-icon, .faux-link';

            // only bind click handler for trigger if we're not manually showing the modal
            // default is false
            if ( ! options.disableTrigger ) {
                $(d).on('click', '[href="' + el.targetElement + '"], [data-modal-id="' + el.targetElement + '"]', function(e){
                    options.beforeShowModal.call(el, el.$modal, $(this));

                    el.showModal();

                    e.preventDefault();

                    options.afterShowModal.call(el, el.$modal, $(this));
                });
            }

            // bind close modal button
            el.$modal.find('.close-modal').on('click', function(e){
                el.closeModal();
                e.preventDefault();
            });

            // if the background overlay is clicked, close the modal
            if ( options.bgClose ) {
                el.$modal
                    .closest('.ui-modal-container')
                    .next('.ui-modal-background')
                    .on('click', function(){
                    el.closeModal();
                });
            }

            // If following a link that leads away from the modal, close it
            el.$modal.find( '.close-modal-link' ).on( 'click', function () {
                el.closeModal();
            });

            // TODO : reference to `this` needs to be changed in this context
            // `this` == the button that's pressed, but should be the reference to the Modal object
            if ( typeof options.accept === 'function' ) {
                $('.bind-accept', el.$modal).off('click').on('click', function({target}){
                    options.accept.call(this, target);
                });
            }

            if ( typeof options.decline === 'function' ) {
                $('.bind-decline', el.$modal).off('click').on('click', function(){
                    options.decline.call( this );
                });
            }

            // handle key presses
            el.$modal.off().on( 'keydown', function ( e ) {
                var _this = this,
                    KEY_TAB = 9,
                    KEY_ENTER = 13,
                    KEY_ESC = 27,
                    KEY_SPACE = 32;

                // if the element with focus is the first focusable element in the modal
                // pressing shift + tab will focus the last focusable element in the modal
                function handleBackwardTab() {
                    if ( el.$modal.find( ':focus' ).is( el.$firstFocusable ) ) {
                        e.preventDefault();
                        el.$lastFocusable.focus();
                    }
                }

                // if the element with focus is the last focusable element in the modal
                // pressing tab will focus the first focusable element in the modal
                function handleForwardTab() {
                    if ( el.$modal.find( ':focus' ).is( el.$lastFocusable ) ) {
                        e.preventDefault();
                        el.$firstFocusable.focus();
                    }
                }

                // triggers callback function when the user presses the space bar or enter key
                // while focusing on the .bind-accept or .bind-decline buttons
                function handleSelect() {
                    var $focusedEl = el.$modal.find( ':focus' );

                    if ( $focusedEl.is( '.bind-accept' ) && options.accept !== null ) {
                        e.preventDefault();
                        options.accept.call( _this );
                    } else if ( $focusedEl.is( '.bind-decline' ) && options.decline !== null ) {
                        e.preventDefault();
                        options.decline.call( _this );
                    } else if ( $focusedEl.is( el.fakeButtonsSelector ) ) {
                        e.preventDefault();
                        $focusedEl.trigger( 'click' );
                    }
                }

                switch ( e.keyCode ) {
                    case KEY_ESC:
                        if ( options.decline !== null ) {
                            // call decline callback if it exists
                            options.decline.call( _this );
                        } else if ( options.bgClose ) {
                            // otherwise close the modal if we are not forcing interaction
                            el.closeModal();
                        }
                        break;
                    case KEY_ENTER:
                        // triggers accept/decline callback if a "button" is focused
                        handleSelect();
                        break;
                    case KEY_SPACE:
                        // triggers accept/decline callback if a "button" is focused
                        handleSelect();
                        break;
                    case KEY_TAB:
                        // creates a tab trap that cycles through focusable elements

                        // if there is only one focusable element, break
                        if ( el.$visibleFocusableElements.length === 1 ) {
                            e.preventDefault();
                            break;
                        }

                        // if the shift key is pressed tab backwards, otherwise tab forwards
                        if ( e.shiftKey ) {
                            handleBackwardTab();
                        } else {
                            handleForwardTab();
                        }

                        break;
                    default:
                        break;
                } // end switch

                el.saveFocusableElements();
            } );

            el.$modal.on( 'change', 'input, textarea, select', function ( e ) {
                el.saveFocusableElements();
            } );

            el.$modal.on( 'click', el.fakeButtonsSelector, function ( e ) {
                el.saveFocusableElements();
            } );

            el.saveFocusableElements();

            // run onInit callback function
            options.onInit.call( el );
        },

        buildModal: function(modal, options){
            const modalClasses = ["ui-modal-container", "hide-content"];

            if (options.background) {
                modalClasses.push(options.background);
            }
            if (options.position) {
                modalClasses.push(options.position);
            }
            if (options.dialog) {
                modalClasses.push("dialog-modal");
            }
            if (options.width) {
                modalClasses.push(options.width);
            }

            const attributes = [
                `class="${modalClasses.join(" ")}"`,
                'role="dialog"',
                `aria-labelledby="${options.labelledById}"`,
                `aria-describedby="${options.describedById}"`,
                'aria-hidden="true"',
            ];

            modal
                .wrap(`<div ${attributes.join(" ")}></div>`)
                .parent()
                .after(
                    '<div class="ui-modal-background ui-secondary-color hide-content"></div>',
                );
        },

        showModal: function () {
            // cancel any pending close so it can't re-hide a re-opened modal
            clearTimeout(this._closeTimeout);

            // save previously focused element
            if (!$(":focus").closest(this.$modal).length) {
                this.$focusedElBeforeOpen = $(":focus");
            }

            this.options.onShow.call(this);

            // remove the hide class that prevents keyboard traps
            this.$modal
                .closest(".ui-modal-container")
                .removeClass("hide-content")
                .next(".ui-modal-background")
                .removeClass("hide-content");

            // NOTE: add a small delay here as the fade in animation will not work correctly immediately after removing hide-content
            function onAnimationReadyHandler(_this) {
                _this.$modal
                    .parent()
                    .addClass("show-modal")
                    .attr("aria-hidden", false);

                if (!Modernizr.csstransforms || !Modernizr.csstransforms3d) {
                    _this.$modal
                        .closest(".ui-modal-container")
                        .next(".ui-modal-background")
                        .fadeTo("fast", 0.9);
                    _this.setPosition();
                }

                _this.saveFocusableElements();

                // focus the first focusable element
                if (_this.$firstFocusable) {
                    _this.$firstFocusable.focus();
                }
            }
            this._showTimeout = setTimeout(onAnimationReadyHandler, 50, this);
        },

        closeModal: function(){
            // cancel any pending open so it can't re-add "show-modal" after we remove it
            clearTimeout(this._showTimeout);

            this.options.onClose.call(this);

            // make fake buttons not focusable
            this.$modal.find(this.fakeButtonsSelector).attr("tabindex", -1);

            this.$modal
                .closest(".ui-modal-container")
                .removeClass("show-modal")
                .attr("aria-hidden", true);

            // hide from the UI after the animation completes to prevent keyboard trap
            function onAnimationCompleteHandler(_this) {
                _this.$modal
                    .closest(".ui-modal-container")
                    .addClass("hide-content")
                    .next(".ui-modal-background")
                    .addClass("hide-content");
            }
            this._closeTimeout = setTimeout(onAnimationCompleteHandler, 400, this);

            this.options.afterCloseModal.call(this, this.$modal);

            this.saveFocusableElements();

            // return focus to the element that was focused before the modal was opened
            if (this.$focusedElBeforeOpen && this.$focusedElBeforeOpen.length) {
                this.$focusedElBeforeOpen.trigger("focus");
            }
        },

        setPosition: function(){
            var modalWidth = this.$modal.width();
            var modalHeight = this.$modal.height();
            var el = this.$modal;
            var marginTop = ( this.options.position == 'modal-centered' ) ? '-' + modalHeight / 2 + 'px' : '';
            var marginLeft = '-' + modalWidth / 2 + 'px';

            this.$modal.closest('.ui-modal-container').css({ 'margin-top' : marginTop, 'margin-left' : marginLeft });
        },

        destroy: function() {
            var el = this;
            // unbuild modal
            el.$modal.closest('.ui-modal-container').next('.ui-modal-background').remove();
            el.$modal.unwrap();

            // unbind event listeners
            if ( ! el.options.disableTrigger ) {
                $(d).off('click', '[href="' + el.targetElement + '"], [data-modal-id="' + el.targetElement + '"]');
            }

            $('.close-modal', el.$modal).off();

            if ( el.options.bgClose ) {
                el.$modal
                    .closest('.ui-modal-container')
                    .next('.ui-modal-background')
                    .off();
            }

            if ( typeof el.options.accept === 'function' ) {
                $('.bind-accept', el.$modal).off();
            }

            if ( typeof el.options.decline === 'function' ) {
                $('.bind-decline', el.$modal).off();
            }

            // reset cache
            el.tabindexAdded = [],
            el.fakeButtonsSelector = null,
            el.$visibleFocusableElements = null,
            el.$firstFocusable = null,
            el.$lastFocusable = null,

            // remove data
            el.$modal.removeData('qg_'+ el._name);
        },

        saveFocusableElements : function () {
            var _this = this,
                visibleFocusableElementsSelector = ':visible:not([type="hidden"])';

            // clear any previously added "tabindex" attributes
            _this.tabindexAdded.forEach( function ( tabbableEl ) {
                _this.$modal.find( tabbableEl ).removeAttr( 'tabindex' );
            } );

            // make fake buttons focusable
            _this.$modal.find( _this.fakeButtonsSelector ).attr( { 'tabindex' : 0, 'role' : 'button' } );

                /**
                 * Focusable Elements
                 * a and area elements that have href attrs
                 * input, select, textarea, and button elements that are not disabled
                 * any element with tabindex of 0
                 */
            var focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]',
                $focusableElements = _this.$modal.find( focusableElementsSelector ),

                /**
                 * Hidden/Disabled Elements (Not focusable, decendants not focusable)
                 * has class or is decendant of element that has class:
                 *      .hide-content
                 *      .hidden-offscreen
                 *      .appearance-disabled
                 *      .chosen-disabled
                 *
                 * also disallows focus for .chosen-select
                 */
                hiddenDisabledElementsSelector = '.hide-content, .hide-content *, .hidden-offscreen, .hidden-offscreen *, .appearance-disabled, .appearance-disabled *, .chosen-disabled *, .chosen-select';

            // make hidden and disabled elements not focusable
            _this.$modal.find( hiddenDisabledElementsSelector )
                .filter( focusableElementsSelector )
                .each( function ( i, hiddenEl ) {
                    _this.$modal.find( hiddenEl ).attr( 'tabindex', -1 );
                    _this.tabindexAdded.push( hiddenEl );
                } );

            // filter $focusableElements to only grab those that are visible (and aren't the child of a hidden element)
            hiddenDisabledElementsSelector.split( ', ' ).forEach( function ( selector ) {
                // generates selector of not hidden and not disabled elements
                visibleFocusableElementsSelector += ':not(' + selector + ')';
            } );
            _this.$visibleFocusableElements = $focusableElements.filter( visibleFocusableElementsSelector );

            // the first and last focusable elements
            // used to jump from the first to the last in tab "focus trap"
            _this.$firstFocusable = $( _this.$visibleFocusableElements[ 0 ] );
            _this.$lastFocusable = $( _this.$visibleFocusableElements[ _this.$visibleFocusableElements.length - 1 ] );
        }
    };

    $.fn[pluginName] = function ( options ) {
        return this.each(function () {
            if ( ! $.data(this, "qg_" + pluginName) ) {
                $.data(this, "qg_" + pluginName,
                new Modal( this, options));
            }
        });
    };

})( jQuery, window, document );
